import { Component } from '@angular/core';
import { LoaderindicatorService } from './Shared/services/loaderindicator/loaderindicator.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './Shared/services/configuration_service/configuration.service';
import { PlatformLocation } from '@angular/common';
import { CommonService } from './Shared/services/common_services/common.service';
import { environment } from 'src/environments/environment';
import { paths } from './Shared/enums/paths.enum';
import { config } from './../assets/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  domainName = false;
  public MGAPIUrl: string;
  public getConfiguration = 'assets/config.json';

  constructor(
    private readonly loadingIndicatorService: LoaderindicatorService,
    private translate: TranslateService,
    private router: Router,
    private httpClient: HttpClient,
    private configurationService: ConfigurationService,
    private location: PlatformLocation,
    private commonService: CommonService,

  ) {
    translate.setDefaultLang(environment.lang);
    // location.onPopState(() => {     
    //   this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
    // });

}
  

  ngOnInit(): void {
    this.restrictDomain();
    this.loadingIndicatorService.show('default');
    // setTimeout(() => {
    //   this.loadingIndicatorService.hide();
    // }, 100);
    //this.createAPIUrl();
  }

  // createAPIUrl(): void {    
  //   this.readConfiguration().then(
  //     result => {
  //       this.configurationService.MGAPIUrl = result.apiHostClient + result.apiURL + result.apiHostVersion;
  //       // localStorage.setItem('url', this.MGAPIUrl);
  //     });
  // }

  // public readConfiguration(): Promise<any> {
  //   return this.httpClient.get(this.getConfiguration).toPromise().then(response => {
  //     return response;
  //   }, error => {
  //     console.log(error);
  //   });
  // }

  public restrictDomain() {
    if (document.referrer.includes(config.domainName)) {
      this.domainName = true;
    } else {
      this.domainName = false;
    }
  }
}
